module.exports = __webpack_public_path__ + "static/media/visa-dark.f6a55e1d.svg";